export function getVisitorId () {
  const waitForPiwik = setInterval(() => {
    if (typeof window.Piwik !== 'undefined') {
      clearInterval(waitForPiwik)
      window.visitorId = window.Piwik.getAsyncTracker().getVisitorId()
    }
  }, 50)
}

export function visitorIdToParam () {
  return `&idlead=${encodeURIComponent(window.visitorId)}`
}
